(function() {
	angular
		.module('trackeye')
		.controller('AuthSsoController', AuthSsoController);

	AuthSsoController.$inject = [
		'AuthService',
		'AccountService',
		'LogService',
		'ModalService',
		'$rootScope',
		'$state'
	];

	function AuthSsoController(AuthService, AccountService, Log, ModalService, $rootScope, $state)
	{
		var vm = this;

		var insecureAccountModal = ModalService.create('insecure-account'),
				termsModal = ModalService.create('accept-terms');

		function acceptTerms(terms, token, close) {
	
			AccountService.updateAccountTerms(terms, true).finally(function() {
				AuthService.saveToken({token: token});
				close();
				$state.go('dashboard.main.pages', {page: 'positions'});
			});
		}
		
		function dontAcceptTerms(terms, close) {
			AccountService.updateAccountTerms(terms, false).finally(function() {
				close();
			});
		}

		vm.loading_text = 'loading'
		vm.listener = $rootScope.$on("$viewContentLoaded", function() {
			ssoAuth($state.params)
		})

		function ssoAuth(params) {
			var code = params.code,
				user = params.user,
				remember = !params.remember ? false : true
				state = params.state,
				error = params.error;

			if (error) {
				vm.loading_text = error
				return
			}

			if (!code || !state) {
				vm.loading_text = "No code or state";
				return
			}

			AuthService.authenticateByCode(code, state, remember).then(function() {
				$state.go('dashboard.main.pages', {page: 'positions'})
			}, function(xhr) {
				if (xhr.Conflict()) {
					var status = xhr.getResponseData('status');
					if (status === 'insecure') {
						insecureAccountModal.open();
						return;
					} else if (status === 'terms_not_accepted') {
						var terms_array = xhr.getResponseData('data'),
							terms = terms_array.pop();

						terms.username = user;
						terms.text = terms.text.replace(/(?:\r\n|\r|\n)/g, '<br>');
						termsModal.open({
							acceptTerms: acceptTerms,
							dontAcceptTerms: dontAcceptTerms,
							terms: terms,
							token: xhr.getResponseData('token')
						});
						return;
					}
				} else {
					Log.handle('Authenticate')(xhr);
					// vm.loginForm.$setValidity('credentials', false);
				}
			}).finally(function() {
				vm.listener()
			});
		}
	}
})();